import { useEffect, useState } from "react";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { JobRoleDetailService } from "../../../../services/JobRoleDetailService";
import JobRoleDetails from "../../../../components/JobRoleDetailsTree/JobRoleDetails";
import TechAreaIntrestHelper from "./TechAreaInterestHelper";
import { TechRoleService } from "../../../../services/TechRoleService";

export default function TechAreaInterest({ searchObject, onChange, t }) {
  const [candidateInterestTechRoles, setCandidateInterestTechRoles] = useState(
    []
  );
  const [candidateInteresrtTechAreas, setCandidateInterestTechAreas] = useState(
    []
  );

  useEffect(() => {
    getTechAreas();
  }, []);

  function getTechAreas() {
    JobRoleDetailService.getAllTechAreas().then((data) => {
      setCandidateInterestTechAreas(data);
    });
  }
  function getTechRoles(techAreaId) {
    JobRoleDetailService.getAllTechRoles(techAreaId).then((data) => {
      setCandidateInterestTechRoles(data);
    });
  }

  useEffect(() => {
    if (searchObject.candidateInterestTechAreaId) {
      getTechRoles(searchObject.candidateInterestTechAreaId);
    } else {
      TechRoleService.getAllTechRoles().then((data) =>
        setCandidateInterestTechRoles(data)
      );
    }
  }, [searchObject.candidateInterestTechAreaId]);

  return (
    <JobRoleDetails
      searchObject={searchObject}
      onChange={onChange}
      techAreas={candidateInteresrtTechAreas}
      techRoles={candidateInterestTechRoles}
      techAreaFieldName="candidateInterestTechAreaId"
      techRoleFieldName="candidateInterestTechRoleId"
    >
      <TechAreaIntrestHelper
        searchObject={searchObject}
        onChange={onChange}
        candidateInteresrtTechAreas={candidateInteresrtTechAreas}
        candidateInterestTechRoles={candidateInterestTechRoles}
      />
    </JobRoleDetails>
  );
}
